import type { FaireProductEntity } from "../../entity_types/product";

export const p_429u8k4uq3: FaireProductEntity = {
  token: "p_429u8k4uq3",
  type: "product",
  name: "Toilet Cleaner - Sweet Citrus Burst",
  brandToken: "b_jqvpsez33t",
  brandName: "Still Magnolia",
  imageUrl:
    "https://cdn.faire.com/fastly/502566822625ee49494313027994dff6a9e90b8fd76cedb6aabd334580ff4589.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.97,
  description:
    "\nIntroducing Our Natural Toilet Cleaner Tablets - A Refreshing Twist for Your Bathroom Routine!\n\n🌿 Transform your bathroom cleaning experience with our Natural Toilet Cleaner Tablets. Each package contains 10 powerful tablets, formulated with a blend of natural ingredients to keep your toilet clean and fresh.\n\nPure Ingredients: Sodium Bicarbonate, Citric Acid, Glycerin, Water, Palm Kernel Flakes, Cocos Nucifera Oil (Coconut Oil), Potassium Hydroxide Pellets, Olea Europaea Fruit Oil (Olive Oil), Simmondsia Chinesis Seed Oil (Jojoba Oil), Tocopheryl Acetate, Cannabis Sativa Seed Oil (Hempseed Oil) and Blend of Essential Oils.\n\n🌱 Why Choose Our Toilet Cleaner Tablets?\n\nCrafted with care and a commitment to natural ingredients, our tablets provide a powerful yet eco-friendly solution for a sparkling clean toilet. Say goodbye to harsh chemicals and hello t\n",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:53.608Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
